export default __webpack_public_path__ + "static/media/uiux.b83cf99b.svg";